import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { notification } from 'antd';

// services
import * as OplevAltService from '../../../../services/bb-api/oplevalt/dashboard';

export const SubscriptionCounters: React.FC = () => {
	const [subscribersMTD, setSubscribersMTD] = useState<number>(0);
	const [subscribersYTD, setSubscribersYTD] = useState<number>(0);
	const [subscribersTotal, setSubscribersTotal] = useState<number>(0);
	const [dates, setDates] = useState({
		startOfToday: '',
		endOfToday: '',
		startOfMonth: '',
		startOfYear: ''
	})

	useEffect(() => {
		const calculateDates = () => { 
			const currentDate = new Date();
		
			const startOfToday = new Date(currentDate.setHours(0, 0, 0, 0)).toISOString();
			const endOfToday = new Date(currentDate.setHours(23, 59, 59, 999)).toISOString();
			const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).toISOString();
			const startOfYear = new Date(currentDate.getFullYear(), 0, 1).toISOString();
		
			setDates({ startOfToday, endOfToday, startOfMonth, startOfYear });
		}

		calculateDates();

		const intervalTime = 60 * 1000 // 60 seconds
		const intervalId = setInterval(calculateDates, intervalTime)
		return () => clearInterval(intervalId)
	}, [])

	useEffect(() => {
		if (dates.startOfToday === dates.endOfToday) return;
		try {
			OplevAltService.activeSubscriptions(new Date(2022, 0, 1).toISOString(), dates.endOfToday).then(setSubscribersTotal);
			OplevAltService.activeSubscriptions(dates.startOfMonth, dates.endOfToday, true).then(setSubscribersMTD);
			OplevAltService.activeSubscriptions(dates.startOfYear, dates.endOfToday, true).then(setSubscribersYTD);
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
	}, [dates])


	return (
		<StyledContainer className='subscription-counters'>
			<div className='flex-item'>
				<p className='label'>Total</p>
				<h1>{subscribersTotal}</h1>
			</div>
			<div className='flex-item'>
				<p className='label'>Måned til dato</p>
				<h1>{subscribersMTD}</h1>
			</div>
			<div className='flex-item'>
				<p className='label'>År til dato</p>
				<h1>{subscribersYTD}</h1>
			</div>
		</StyledContainer>
	);
};

const StyledContainer = styled.div`
	display: flex;

	h1 {
		font-size: 84px;
		font-weight: 700;
		line-height: 1em;
		color: #ffffff;
		margin: 0;
	}

	.label {
		color: #9ca3af;
		font-size: 32px;
		margin: 0;
	}

	.flex-item {
		display: flex;
		flex: 1;
		flex-direction: column;
		background-color: rgba(31, 41, 55, 1);
		height: 180px;
		margin: 1em;
		padding: 12px 48px;
		border-radius: 12px;
		box-shadow: rgba(0,0,0,0.2) 0px 2px 8px 0px;
	}
`;
